module.exports = __webpack_public_path__ + "static/media/Group 426.282e4ed0.png";